import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61ec24b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding":"20px"} }
const _hoisted_2 = { class: "error-alert" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "导入结果: 整批导入失败", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "错误内容:", -1))
const _hoisted_5 = { style: {"justify-content":"center","display":"flex","margin":"10px"} }

import { withDefaults, ref, computed } from 'vue';
import {
  BaseButton,
  BaseTable,
  BaseTableProps,
  BaseInput,
  useTableColumn,
  XrkMessage,
  createDialog,
  BasePagination,
  XrkMessageBox
} from 'xrk-components';
import { getOriginalExcel, cancelImportExcel } from '../data-source/apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'project-person-fail-table',
  props: {
    done: { type: Function, default: null },
    importCount: {},
    failCount: {},
    dataList: {},
    form: { default: () => ({
      excelCode: ''
    }) }
  },
  emits: ['againSubmit'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const currentPage = ref(1);
const pageSize = ref(15);

const emits = __emit;

const tableData = ref(props.dataList);
const isCellShow = ref(null);
const sizeSuccess = computed(() => {
  return `导入${props.importCount}条，失败${props.failCount}条`;
});

const excelErrorDownload = () => {
  getOriginalExcel({ excelCode: props.form.excelCode });
};
const tablePageData = ref(
  tableData.value.slice(
    (currentPage.value - 1) * pageSize.value,
    currentPage.value * pageSize.value
  )
);

const handleSizeChange = ({ currentPage, pageSize }) => {
  tablePageData.value = tableData.value.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
};

const columns: BaseTableProps['columns'] = [
  useTableColumn({
    label: '表格位置',
    prop: 'rowNumStr',
    fixed: 'left'
  }),
  useTableColumn({
    label: '姓名',
    prop: 'name',
    width: '160px',
    render: ({ row }) => {
      return isCellShow.value === 'name' + row.rowNum ? (
        <BaseInput
          placeholder="请输入姓名"
          ref="editInput"
          onInput={e => {
            row.name = e;
          }}
          v-model={row.name}
          onBlur={() => {
            isCellShow.value = '';
          }}
        ></BaseInput>
      ) : (
        <BaseButton
          onClick={() => {
            isCellShow.value = 'name' + row.rowNum;
          }}
          type="text"
        >
          {row.name || '-'}
        </BaseButton>
      );
    }
  }),
  useTableColumn({
    label: '手机号',
    prop: 'phone',
    width: '160px',
    render: ({ row }) => {
      return isCellShow.value === 'phone' + row.rowNum ? (
        <BaseInput
          type="tel"
          ref="editInput"
          placeholder="请输入手机号"
          onInput={e => {
            row.phone = e;
          }}
          v-model={row.phone}
          onBlur={() => {
            isCellShow.value = '';
          }}
        ></BaseInput>
      ) : (
        <BaseButton
          onClick={() => {
            isCellShow.value = 'phone' + row.rowNum;
          }}
          type="text"
        >
          {row.phone || '-'}
        </BaseButton>
      );
    }
  }),
  useTableColumn({
    label: '预采购任务量',
    prop: 'procurementTaskQuantity',
    render: ({ row }) => {
      const inputRule = num => {
        let errMsg = '';
        if (+num > 1000000) {
          errMsg = '输入数字不可大于1000000';
          row.procurementTaskQuantity = 1000000;
        }
        if (+num <= 0) {
          errMsg = '请输入正整数';
          row.procurementTaskQuantity = 1;
        }
        if (errMsg) {
          createDialog({
            width: '300px',
            title: '提示',
            showClose: true,
            showFooter: false,
            content: errMsg
          });
          return;
        }
        row.procurementTaskQuantity = num;
      };
      return isCellShow.value === 'procurementTaskQuantity' + row.rowNum ? (
        <BaseInput
          ref="editInput"
          type="tel"
          maxlength={7}
          placeholder="请输入预采购任务量"
          onInput={e => {
            inputRule(e);
          }}
          v-model={row.procurementTaskQuantity}
          onBlur={() => {
            isCellShow.value = '';
          }}
        ></BaseInput>
      ) : (
        <BaseButton
          onClick={() => {
            isCellShow.value = 'procurementTaskQuantity' + row.rowNum;
          }}
          type="text"
        >
          {row.procurementTaskQuantity ?? '-'}
        </BaseButton>
      );
    }
  }),
  useTableColumn({
    label: '人员标签',
    prop: 'userTag',
    width: '160px',
    render: ({ row }) => {
      return isCellShow.value === 'userTag' + row.rowNum ? (
        <BaseInput
          maxlength={10}
          ref="editInput"
          placeholder="请输人员标签"
          onInput={e => {
            row.userTag = e;
          }}
          v-model={row.userTag}
          onBlur={() => {
            isCellShow.value = '';
          }}
        ></BaseInput>
      ) : (
        <BaseButton
          onClick={() => {
            isCellShow.value = 'userTag' + row.rowNum;
          }}
          type="text"
        >
          {row.userTag || '-'}
        </BaseButton>
      );
    }
  }),
  useTableColumn({
    label: '错误提示',
    width: '300px',
    render: ({ row }) => {
      return row.errorMsgList.map((item, index) => {
        return <p>{`${index + 1}.${item.errorMsg}`}</p>;
      });
    }
  }),
  useTableColumn({
    label: '操作',
    fixed: 'right',
    render: ({ index }) => {
      return (
        <BaseButton
          onClick={() => {
            XrkMessageBox.confirm('此操作将删除该项, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消'
            }).then(() => {
              tableData.value.splice(index, 1);
              tablePageData.value = tableData.value.slice(
                (currentPage.value - 1) * pageSize.value,
                currentPage.value * pageSize.value
              );
              XrkMessage({
                type: 'success',
                message: '删除成功!'
              });
            });
          }}
          type="text"
        >
          删除
        </BaseButton>
      );
    }
  })
];

async function onSubmit() {
  await XrkMessageBox.confirm('是否确认重新提交？');
  emits('againSubmit', {
    dataList: tableData.value
  });
  props.done();
}
const onCancel = async () => {
  await cancelImportExcel({ excelCode: props.form.excelCode });
  props.done();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, " 信息校验结果: " + _toDisplayString(sizeSuccess.value), 1),
      _hoisted_3,
      _hoisted_4
    ]),
    (_openBlock(), _createBlock(_unref(BaseTable), {
      style: {"min-height":"300px"},
      ref: "baseTableRef",
      data: (tablePageData.value as any[]),
      columns: columns,
      key: tableData.value.length
    }, null, 8, ["data"])),
    _createVNode(_unref(BasePagination), {
      "current-page": currentPage.value,
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
      "page-size": pageSize.value,
      "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
      "page-sizes": [15, 60, 100],
      layout: "total, sizes, prev, pager, next, jumper",
      total: tableData.value.length,
      onSizeChange: handleSizeChange,
      onCurrentChange: handleSizeChange
    }, null, 8, ["current-page", "page-size", "total"]),
    _createVNode(_unref(BaseButton), {
      onClick: excelErrorDownload,
      style: {"margin":"20px 0"}
    }, {
      default: _withCtx(() => [
        _createTextVNode(" 下载错误Excel ")
      ]),
      _: 1
    }),
    _createElementVNode("span", _hoisted_5, [
      _createVNode(_unref(BaseButton), { onClick: onCancel }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), {
        type: "primary",
        onClick: onSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode("重新提交")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})